import { Type } from 'class-transformer';
import * as moment from 'moment-timezone';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { GLAccountLabelSelectorResultDto } from '../../common/gl-account/gl-account-label-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { ARInvoiceRawDto } from './ar-invoice-raw-dto';

export class ARInvoiceEditorResultDto {
    @Type(() => KeyValueResultDto)
    subLedgers: KeyValueResultDto[];
    @Type(() => GLAccountLabelSelectorResultDto)
    glAccountLabels: GLAccountLabelSelectorResultDto[];
    @Type(() => GLAccountSelectorResultDto)
    glAccounts: GLAccountSelectorResultDto[];
    @Type(() => DimensionSelectorResultDto)
    glDimensions: DimensionSelectorResultDto[];
    @Type(() => Date)
    closedBookPeriodDate: Date;
    entityUsesSubCategory: boolean;
    hasCreditApplications: boolean;
    allowFullEdit: boolean;
    allowPartialEdit: boolean;
    allowOtherDimensionEdit: boolean;
    allowAddDeleteLineItems: boolean;
    defaultOffsetGLAccountNumber: string;
    @Type(() => FileInfoDisplayResultDto)
    attachments: FileInfoDisplayResultDto[];
    @Type(() => FileInfoDisplayResultDto)
    supportDocument: FileInfoDisplayResultDto;
    @Type(() => UpdatedResultDto)
    updatedDetails: UpdatedResultDto;
    name: string;
    documentType: string;
    @Type(() => ARInvoiceRawDto)
    invoiceInfo: ARInvoiceRawDto;

    get minPostDate(): Date {
        return !!this.closedBookPeriodDate ? moment(this.closedBookPeriodDate).add(1, 'day').toDate() : null;
    }
}
